<button
  [disabled]="this.disabled()"
  [matMenuTriggerFor]="cameraSelectMenu"
  matTooltip="Choose your camera"
  [class]="
    variant() === 'default'
      ? '!min-w-0 !rounded-none !border-none !bg-white !px-2 !py-6 !shadow-none sm:!border-l-0 sm:!border-r-0 md:!border-solid xl:!px-4'
      : '!border-l-0 !border-r-0 !bg-white !px-8 !py-[2.875rem] !shadow-none'
  "
  mat-stroked-button
>
  <span class="flex flex-col gap-1">
    <div class="m-auto flex flex-row items-center">
      <mat-icon class="text-black-300">videocam</mat-icon>
      <mat-icon class="text-black-300">keyboard_arrow_up</mat-icon>
    </div>
    <span class="hidden font-semibold text-black-300 xl:!inline-block">Camera</span>
  </span>
</button>

<mat-menu #cameraSelectMenu xPosition="after" yPosition="above">
  @for (item of cameraOptions(); track item.media.deviceId) {
    <button (click)="emitSelection(item.media)" class="!rounded-none" mat-menu-item>
      <span [ngClass]="{ underline: item.selected }">{{ item.media.label | cleanDeviceLabel }}</span>
    </button>
  }
  <hr class="border-[#EEEEF0]" />
  <button (click)="emitSelection(null)" class="!rounded-none" mat-menu-item>
    <span [ngClass]="{ underline: false }" class="text-[#BA1A1A]">Disable camera</span>
  </button>
</mat-menu>
